import ComoFazemos from "../../components/comoFazemos";
import Rodape from "../../components/rodape";
import BusinessOtimize from "../../components/businessOtimize";
import BusinessBeneficios from "../../components/businessBeneficios";
import BannerProjects from "../../components/bannerProjects";

function GestaoMudanca() {
    return (
        <>
            <BannerProjects
                backgroundImage="../assets/cover-gestao-mudanca.png"
                bgMobile="../assets/cover-gestao-mudanca-mobile.png"
                title="/GESTÃO"
                titleBold="DA MUDANÇA"
                iconSrc="../assets/icone-projectiva-behub.png"
                iconAlt="Projectiva BeHub"
                iconText="be."
                iconTextBold="hub"
                descriptionBold="MAIS DO QUE METODOLOGIA:"
                description="para implementar a agilidade é preciso uma mudança cultural e operacional, garantindo uma transição eficiente e o engajamento das equipes."
                footerText="VERTICAL PROJECTS | Business Agility"
                buttonText="Quero me conectar"
                buttonColor="from-[#4B3BDB] to-[#A002CB]"
                brand="behub"
            />
            <ComoFazemos
                title="Como fazemos?"
                cards={[
                    {
                        icon: "/assets/servicos/facilitacao_icon.svg",
                        iconHover: "/assets/servicos/facilitacao_icon.svg",
                        title: "Facilitação da Transição:",
                        text: "Garantimos uma transição cultural e operacional suave, abordando as resistências e promovendo a aceitação das novas práticas.",
                        glowColor: "#A002CB",
                        height: "350"
                    },
                    {
                        icon: "/assets/servicos/engajamento_icon.svg",
                        iconHover: "/assets/servicos/engajamento_icon.svg",
                        title: "Engajamento da Equipe:",
                        text: "Trabalhamos para maximizar o engajamento dos colaboradores, integrando mudanças de forma que todos se sintam parte do processo.",
                        glowColor: "#A002CB",
                        height: "350"
                    },
                    {
                        icon: "/assets/servicos/adocao_icon.svg",
                        iconHover: "/assets/servicos/adocao_icon.svg",
                        title: "Adoção Eficaz:",
                        text: "Asseguramos que as novas metodologias sejam adotadas de forma eficaz, alinhando a mudança com os objetivos da organização.",
                        glowColor: "#A002CB",
                        height: "350"
                    },
                ]}
            />
            <BusinessOtimize
                backgroundImage="../assets/background_mudancas.png"
                bgMobile="../assets/background_mudancas2_mobile.png"
                title={
                    <>
                        Lidere uma mudança cultural que impulsiona a<br />
                        agilidade e{" "}
                        <span className="font-inter-bold">
                            resultados reais
                        </span>
                        .
                    </>
                }
                buttonText="Otimize seu negócio"
                buttonTextColor="from-[#A800E4] to-[#A800E4]"
                buttonLink="#"
            />
            <BusinessBeneficios
                title="Benefícios"
                text={
                    <>
                        <strong>
                            Transformações reais, projetos efetivos.
                        </strong>{" "}
                        A gestão da mudança oferece entregas tangíveis para as
                        empresas.
                    </>
                }
                buttonText="Otimize seu negócio!"
                buttonLink="#"
                buttonActionText="Contratar"
                items={[
                    {
                        icon: "/assets/servicos/engajamento_icon_purple.svg",
                        title: "ENGAJAMENTO AMPLIFICADO",
                        description:
                            "Colaboradores mais envolvidos e alinhados com os objetivos da empresa.",
                    },
                    {
                        icon: "/assets/servicos/resistencia_icon_purple.svg",
                        title: "RESISTÊNCIA REDUZIDA",
                        description:
                            "Mudança implementada com menor resistência e maior adoção.",
                    },
                    {
                        icon: "/assets/servicos/adocao_icon_purple.svg",
                        title: "ADOÇÃO SUSTENTÁVEL",
                        description:
                            "Práticas ágeis, integradas de forma duradoura e eficiente.",
                    },
                    {
                        icon: "/assets/servicos/melhoria_icon_purple.svg",
                        title: "MELHORIA CONTÍNUA",
                        description:
                            "Ambiente de trabalho que promove adaptação e crescimento constante.",
                    },
                ]}
            />
            <Rodape />
        </>
    );
}

export default GestaoMudanca;
